/* eslint-disable no-console */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { Configuration, LogLevel } from '@azure/msal-browser';

export const b2cPolicies = {
	authorities: {
		myGovID: {
			authority: process.env.NEXT_PUBLIC_WIQ_MSAL_CONFIG_SIGNUPSIGNIN,
		},
		localAccount: {
			authority: process.env.NEXT_PUBLIC_WIQ_MSAL_CONFIG_LOCAL_SIGNUPSIGNIN,
		},
	},
	authorityDomain: process.env.NEXT_PUBLIC_WIQ_MSAL_CONFIG_AUTHORITY_DOMAIN ?? '',
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
	auth: {
		clientId: `${process.env.NEXT_PUBLIC_WIQ_MSAL_CONFIG_CLIENTID}`, // This is the ONLY mandatory field that you need to supply.
		authority: b2cPolicies.authorities.myGovID.authority, // The Authority URL for AzureB2C policy. Defaults to myGovID
		knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
		redirectUri: `${process.env.NEXT_PUBLIC_WIQ_MSAL_CONFIG_REDIRECTURI}`, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
		postLogoutRedirectUri: `${process.env.NEXT_PUBLIC_WIQ_MSAL_CONFIG_POSTLOGOUTREDIRECTURI}`, // Indicates the page to navigate after logout.
	},
	cache: {
		cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
	},
	system: {
		loggerOptions: {
			loggerCallback: (level, message, containsPii) => {
				if (containsPii) {
					return;
				}
				switch (level) {
					case LogLevel.Error:
						console.error(message);
						return;
					default:
						return;
				}
			},
		},
	},
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
	apiHello: {
		scopes: [`${process.env.NEXT_PUBLIC_WIQ_MSAL_CONFIG_SCOPE}`, 'openid', 'offline_access'],
	},
};
